import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import SelectData from "../../../PopUp/SelectData";
import PropTypes from "prop-types";

export default function InputData1(props) {
  const { MainGroup, SubGroup } = props;

  const [state, setState] = useState({
    SMainGroup: "",
    SSubGroup: "",
  });

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      SMainGroup: MainGroup,
      SSubGroup: SubGroup,
    }));
    return () => {};
  }, [MainGroup, SubGroup]);

  const RsSelect = (e, val) => {
    // console.log(e, val)
    props.GetData("data1", [e, val]);
  };
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={8}>
          <SelectData
            origin="Maingroup" // กลุ่มลูกค้าหลัก
            valueSelect={(e) => RsSelect("Maingroup", e)} // รับค่ากลับ
            title="กลุ่มลูกค้าหลัก"
            defaultselect={state.SMainGroup} // ค่าเริ่มต้นของ กลุ่มลูกค้าหลัก
          />
        </Grid>
        <Grid item xs={8}>
          <SelectData
            origin="Subgroup1" // กลุ่มลูกค้าย่อย 1
            valueSelect={(e) => RsSelect("Subgroup1", e)} // รับค่ากลับ
            title="กลุ่มลูกค้าย่อย 1"
            defaultselect={state.SSubGroup} // ค่าเริ่มต้นของ กลุ่มลูกค้าย่อย 1
          />
        </Grid>
      </Grid>
    </>
  );
}

InputData1.propTypes = {
  MainGroup: PropTypes.string,
  SubGroup: PropTypes.string,
};
InputData1.defaultProps = {
  MainGroup: "",
  SubGroup: "",
};
